export const constructGetRequestOptions = () => {
  return {
    method: 'GET',
    credentials: 'include' as RequestCredentials,
  };
};
